import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback, useEffect, useState } from 'react';
import { getLatestFeedbackPrompt, getTask, dismissFeedbackPrompt } from '@poplar/lib/api/tasks';
import { ApiResponseStatus } from '@poplar/lib/api/utils';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { useToast } from '@yoweb/ui/hooks/useToast';
import { useTranslation } from '@yoweb/next-i18next';
export var useFeedbackToast = function useFeedbackToast(openFeedbackFlyout) {
  var _useTranslation = useTranslation('tasks'),
      t = _useTranslation.t;

  var _useToast = useToast(),
      showToastAction = _useToast.showToastAction;

  var _useExternalConfig = useExternalConfig(),
      globalFeatures = _useExternalConfig.globalFeatures;

  var _useState = useState(null),
      latestFeedbackPrompt = _useState[0],
      setLatestFeedbackPrompt = _useState[1];

  var _useState2 = useState(null),
      taskDetails = _useState2[0],
      setTaskDetails = _useState2[1];

  var _useState3 = useState(false),
      isError = _useState3[0],
      setIsError = _useState3[1];

  var _useState4 = useState(false),
      isFetchSuccessful = _useState4[0],
      setIsFetchSuccessful = _useState4[1];

  var _useState5 = useState(false),
      noTasksAvailable = _useState5[0],
      setNoTasksAvailable = _useState5[1];

  var _useState6 = useState(false),
      isToastShown = _useState6[0],
      setIsToastShown = _useState6[1];

  var _useState7 = useState(null),
      lastShownTaskId = _useState7[0],
      setLastShownTaskId = _useState7[1];

  useEffect(function () {
    function fetchPrompt() {
      return _fetchPrompt.apply(this, arguments);
    }

    function _fetchPrompt() {
      _fetchPrompt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _taskResponse$data, response, taskResponse;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (globalFeatures.enableUpdateMemberFeedback) {
                  _context.next = 3;
                  break;
                }

                setIsFetchSuccessful(false);
                return _context.abrupt("return");

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return getLatestFeedbackPrompt();

              case 6:
                response = _context.sent;

                if (!(response.status !== ApiResponseStatus.OK || !response.data)) {
                  _context.next = 11;
                  break;
                }

                setNoTasksAvailable(true);
                setIsFetchSuccessful(false);
                return _context.abrupt("return");

              case 11:
                setLatestFeedbackPrompt(response.data.taskId);
                setNoTasksAvailable(false);
                _context.next = 15;
                return getTask(response.data.taskId);

              case 15:
                taskResponse = _context.sent;

                if (!(taskResponse.status !== ApiResponseStatus.OK || !((_taskResponse$data = taskResponse.data) !== null && _taskResponse$data !== void 0 && _taskResponse$data.task))) {
                  _context.next = 18;
                  break;
                }

                throw new Error('Failed to fetch task details');

              case 18:
                setTaskDetails(taskResponse.data.task);
                setIsFetchSuccessful(true);
                _context.next = 27;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](3);
                setIsError(true);
                setIsFetchSuccessful(false);
                throw _context.t0;

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 22]]);
      }));
      return _fetchPrompt.apply(this, arguments);
    }

    void fetchPrompt();
  }, [globalFeatures.enableUpdateMemberFeedback]);
  var dismissPrompt = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(taskId) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (taskId) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return dismissFeedbackPrompt(taskId);

            case 5:
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](2);
              setIsError(true);
              throw _context2.t0;

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  var showFeedbackToast = useCallback(function () {
    if (!latestFeedbackPrompt || !taskDetails || isError || isToastShown || latestFeedbackPrompt === lastShownTaskId) {
      return;
    }

    showToastAction({
      message: t('todo-feedback.toast-title'),
      ctaText: t('toasts.view-todo', {
        ns: 'common'
      }),
      onClick: function onClick() {
        return openFeedbackFlyout({
          taskId: latestFeedbackPrompt,
          name: taskDetails.name,
          updated: taskDetails.updated
        }, 0);
      },
      onClose: function () {
        var _onClose = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (latestFeedbackPrompt) {
                    _context3.next = 2;
                    break;
                  }

                  return _context3.abrupt("return");

                case 2:
                  _context3.prev = 2;
                  _context3.next = 5;
                  return dismissPrompt(latestFeedbackPrompt);

                case 5:
                  setIsToastShown(false);
                  _context3.next = 12;
                  break;

                case 8:
                  _context3.prev = 8;
                  _context3.t0 = _context3["catch"](2);
                  setIsError(true);
                  throw _context3.t0;

                case 12:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[2, 8]]);
        }));

        function onClose() {
          return _onClose.apply(this, arguments);
        }

        return onClose;
      }()
    });
    setIsToastShown(true);
    setLastShownTaskId(latestFeedbackPrompt);
  }, [latestFeedbackPrompt, taskDetails, isError, isToastShown, lastShownTaskId, t, showToastAction, dismissPrompt, openFeedbackFlyout]);
  useEffect(function () {
    showFeedbackToast();
  }, [showFeedbackToast]);
  return {
    taskDetails: taskDetails,
    latestFeedbackPrompt: latestFeedbackPrompt,
    dismissPrompt: dismissPrompt,
    isError: isError,
    isFetchSuccessful: isFetchSuccessful,
    noTasksAvailable: noTasksAvailable
  };
};